/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-triangle': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<g id="Layer_1"><path pid="0" d="M16.1 4c.7 0 1.3.3 1.7.9l11.9 18.9c.6.9.2 1.7.1 2-.2.3-.7 1-1.8 1H4.1c-1.1 0-1.6-.7-1.8-1-.2-.3-.5-1.1.1-2L14.4 5c.3-.6 1-1 1.7-1m0-2c-1.3 0-2.6.6-3.4 1.9L.8 22.8C-.9 25.5 1 29 4.1 29H28c3.1 0 5.1-3.5 3.4-6.1l-11.9-19C18.7 2.7 17.4 2 16.1 2z"/><path pid="1" d="M15 8h2v12h-2z"/><circle pid="2" cx="16" cy="23.5" r="1.5"/></g>'
  }
})
